import { combineReducers } from '@reduxjs/toolkit';

import { systemReducer } from '../pods/system/state/reducer';
import { userReducer, practitionerReducer } from '../pods/user/state/reducer';
import { sessionReducer } from '../pods/sessions/state/reducer';
import { onboardingReducer } from 'src/pods/onboarding/state/reducers';

const appReducer = combineReducers({
    systemReducer,
    userReducer,
    practitionerReducer,
    sessionReducer,
    onboardingReducer,
});

export const rootReducer = (state: ReturnType<typeof appReducer>, action: any) => {
    return appReducer(state, action);
};

export type RootState = ReturnType<typeof rootReducer>;
